import { defineNuxtPlugin } from '#app/nuxt'
import { LazyArticleBlogAttending, LazyArticleBlogExpect, LazyArticleBlogFeedback, LazyArticleBlogRenegades, LazyArticleBlogSurvival, LazyArticleBlogYorkshire, LazyArticleContact, LazyArticleCookies, LazyArticleCookiesAnalytical, LazyArticleCookiesNecessary, LazyArticleCookiesPayment, LazyArticleCookiesWhatAre, LazyArticleFaqsDescription, LazyArticleFaqsTileBooking, LazyArticleFaqsTileClothes, LazyArticleFaqsTileCovid, LazyArticleFaqsTileExperience, LazyArticleFaqsTilePartner, LazyArticleHome, LazyArticleMusicDescription, LazyArticlePrivacy, LazyArticleTermsConditions, LazyArticleTermsDefinitions, LazyArticleTermsExclusions, LazyArticleTermsMedia, LazyArticleTermsWebsite, LazyArticleVenueDescription, LazyArticleVenueTitle, LazyFormLoginSignup, LazyFormSubscriptionCancel, LazyFormSubscriptionMethodAdd, LazyIconBadge, LazyIconCard, LazyIconChevronRight, LazyIconClose, LazyIconDocument, LazyIconEdit, LazyIconLocation, LazyIconRefresh, LazyIconSelected, LazyIconTrash } from '#components'
const lazyGlobalComponents = [
  ["ArticleBlogAttending", LazyArticleBlogAttending],
["ArticleBlogExpect", LazyArticleBlogExpect],
["ArticleBlogFeedback", LazyArticleBlogFeedback],
["ArticleBlogRenegades", LazyArticleBlogRenegades],
["ArticleBlogSurvival", LazyArticleBlogSurvival],
["ArticleBlogYorkshire", LazyArticleBlogYorkshire],
["ArticleContact", LazyArticleContact],
["ArticleCookies", LazyArticleCookies],
["ArticleCookiesAnalytical", LazyArticleCookiesAnalytical],
["ArticleCookiesNecessary", LazyArticleCookiesNecessary],
["ArticleCookiesPayment", LazyArticleCookiesPayment],
["ArticleCookiesWhatAre", LazyArticleCookiesWhatAre],
["ArticleFaqsDescription", LazyArticleFaqsDescription],
["ArticleFaqsTileBooking", LazyArticleFaqsTileBooking],
["ArticleFaqsTileClothes", LazyArticleFaqsTileClothes],
["ArticleFaqsTileCovid", LazyArticleFaqsTileCovid],
["ArticleFaqsTileExperience", LazyArticleFaqsTileExperience],
["ArticleFaqsTilePartner", LazyArticleFaqsTilePartner],
["ArticleHome", LazyArticleHome],
["ArticleMusicDescription", LazyArticleMusicDescription],
["ArticlePrivacy", LazyArticlePrivacy],
["ArticleTermsConditions", LazyArticleTermsConditions],
["ArticleTermsDefinitions", LazyArticleTermsDefinitions],
["ArticleTermsExclusions", LazyArticleTermsExclusions],
["ArticleTermsMedia", LazyArticleTermsMedia],
["ArticleTermsWebsite", LazyArticleTermsWebsite],
["ArticleVenueDescription", LazyArticleVenueDescription],
["ArticleVenueTitle", LazyArticleVenueTitle],
["FormLoginSignup", LazyFormLoginSignup],
["FormSubscriptionCancel", LazyFormSubscriptionCancel],
["FormSubscriptionMethodAdd", LazyFormSubscriptionMethodAdd],
["IconBadge", LazyIconBadge],
["IconCard", LazyIconCard],
["IconChevronRight", LazyIconChevronRight],
["IconClose", LazyIconClose],
["IconDocument", LazyIconDocument],
["IconEdit", LazyIconEdit],
["IconLocation", LazyIconLocation],
["IconRefresh", LazyIconRefresh],
["IconSelected", LazyIconSelected],
["IconTrash", LazyIconTrash],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
